import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

import useAppContext from '../../context/useAppContext';
import RatesManager, { generateClassNameRateName } from '../rates/components/rateManager';
import { InheritedProperty } from '../rates/ratesList';
import { RateCategorySeat } from '../rates/components/rateCategorySeat';
import { RateBundleInfo } from '../rates/components/rateBundleInfo';
import StyleRM from './../../pages/rates/components/rateManager.module.css';
import { Card as NacreCard } from './../../components/card';
import { CountAttendees } from './channelsStats';

export default function RatesStats({ stats = null }) {
    const { t } = useTranslation();
    const [{ organization, event }] = useAppContext();

    const statistics = React.useMemo(() => {
        if (!stats) {
            return null;
        }

        return stats.find(groupStats => groupStats.name === 'sales_by_rate_stats').value;
    }, [stats]);

    let tableCells = React.useMemo(() => {
        return [
            {
                header: t('ticket.rates.rateName'),
                renderRate: (rate, { categories, groups }) => {
                    return (
                        <InheritedProperty
                            displayIcon={false}
                            property="name"
                            object={rate}
                            handleProperty={name => (
                                <div className={StyleRM[generateClassNameRateName(rate, groups)]} style={{ display: 'flex', alignItems: 'center' }}>
                                    <RateCategorySeat event={event} rate={rate} categories={categories} />
                                    {name}
                                    <RateBundleInfo bundleSize={rate.bundle_size || 1} />
                                </div>
                            )}
                            template="rate_template"
                        />
                    );
                },
                renderGroup: (group, onToggle) => {
                    return (
                        <div className={StyleRM['rates-table__cell-group']} onClick={() => onToggle(group)}>
                            {group.parent && <Icon className={StyleRM['rates-table__cell-group-icon-subgroup']} name="link-group" />}
                            <Icon name={group.showRates ? 'folder-open' : 'folder-closed'} style={{ marginRight: '5px' }} />
                            <InheritedProperty displayIcon={false} property="name" object={group} handleProperty={name => <b>{name}</b>} template="group_template" />
                        </div>
                    );
                }
            },
            {
                header: t('ticket.common.attendee_plural'),
                renderRate: rate => {
                    return <CountAttendees data={statistics.rates[rate.pk]} />;
                },
                renderGroup: group => {
                    return <CountAttendees data={statistics.groups[group.pk]} />;
                }
            }
        ];
    }, [statistics]);

    return (
        <NacreCard separator={false}>
            <RatesManager
                event={event}
                organization={organization}
                initialQuery={{
                    organizationId: organization.id,
                    eventId: event.id
                }}
                tableCells={tableCells}
                mode={'rates_stats'}
                selectable={false}
                activeSyncRates={false}
                activeCacheRates
                activeCacheGroups
            />
        </NacreCard>
    );
}

RatesStats.propTypes = {
    stats: PropTypes.array
};
